import { render, staticRenderFns } from "./video_aliplayer_v2.vue?vue&type=template&id=4df7a994&scoped=true"
import script from "./video_aliplayer_v2.vue?vue&type=script&lang=js"
export * from "./video_aliplayer_v2.vue?vue&type=script&lang=js"
import style0 from "./video_aliplayer_v2.vue?vue&type=style&index=0&id=4df7a994&prod&lang=scss&scoped=true"
import style1 from "./video_aliplayer_v2.vue?vue&type=style&index=1&id=4df7a994&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df7a994",
  null
  
)

export default component.exports